<template>
  <div class="TeachingData">
    <AppHeader>教学数据</AppHeader>
    <AppBox class="appBox">
      <!--      <el-date-picker-->
      <!--          style="width: 250px"-->
      <!--          v-model="dateRange"-->
      <!--          :picker-options="pickerOptions"-->
      <!--          value-format="timestamp"-->
      <!--          type="daterange"-->
      <!--          range-separator="-"-->
      <!--          start-placeholder="开始日期"-->
      <!--          end-placeholder="结束日期"-->
      <!--          @change="onSubmit"-->
      <!--      >-->
      <!--      </el-date-picker>-->
      <el-form :inline="true">
        <el-form-item>
          <date-select ref="datePicker" @pick="datePicked"></date-select>
        </el-form-item>
        <el-form-item label="工作单位" prop="unitName">
          <el-input v-model="unitName" @change="onSubmit"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="onSubmit"
          >查找
          </el-button>
          <el-button size="mini" @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="display: flex;">
        <div class="echarts-div">
          <VChart class="echarts" ref="chart1" autoresize></VChart>
        </div>
        <div class="echarts-div">
          <VChart class="echarts" ref="chart2" autoresize></VChart>
        </div>
      </div>
      <div style="display: flex;">
        <div class="echarts-div">
          <VChart class="echarts" ref="chart3" autoresize></VChart>
        </div>
        <div class="echarts-div">
          <VChart class="echarts" ref="chart4" autoresize></VChart>
        </div>
      </div>
      <div style="display: flex;">
        <div class="echarts-div">
          <VChart class="echarts" ref="chart5" autoresize></VChart>
        </div>
        <div class="echarts-div">
          <VChart class="echarts" ref="chart6" autoresize></VChart>
        </div>
      </div>
      <div style="display: flex;">
        <div class="echarts-div">
          <VChart class="echarts" ref="chart7" autoresize></VChart>
        </div>
        <div class="echarts-div">
          <VChart class="echarts" ref="chart8" autoresize></VChart>
        </div>
      </div>
      <div style="display: flex;">
        <div class="echarts-div">
          <VChart class="echarts" ref="chart9" autoresize></VChart>
        </div>
        <div class="echarts-div">
          <VChart class="echarts" ref="chart10" autoresize></VChart>
        </div>
      </div>
    </AppBox>
  </div>
</template>

<script>
import {use} from 'echarts/core';
import {CanvasRenderer} from 'echarts/renderers';
import {PieChart} from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';
import {BarChart} from 'echarts/charts';
import AppBox from "@/components/ui/AppBox/index.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import {mapActions} from "vuex";
import DateSelect from "@/components/dateSelect/index.vue";
import DateUtil from "@/utils/formatDate";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  BarChart,
  ToolboxComponent,
  DataZoomComponent,
]);


export default {
  name: "TeachingData",
  components: {DateSelect, AppHeader, AppBox, VChart},
  computed: {},
  data() {
    return {
      dateRange: [],
      countDistinctUser: {
        field: "userId",
        type: "countDistinct"
      },
      unitName: null,
      actDate: [new Date().getTime() - 3600 * 1000 * 24, new Date().getTime()],
    }
  },
  async mounted() {
    this.$refs.datePicker.onSubmit();
  },
  methods: {
    ...mapActions("dataCenter", ["getAnalyseData"]),
    datePicked(date) {
      if (date === null)
        date = [];
      this.dateRange = date
      this.refreshAll();
    },
    onReset() {
      this.unitName = null;
      this.refreshAll();
    },
    onSubmit() {
      this.refreshAll();
    },
    refreshAll() {
      this.refreshChart1();
      this.refreshChart2();
      this.refreshChart3();
      this.refreshChart4();
      this.refreshChart5();
      this.refreshChart6();
      this.refreshChart7();
      this.refreshChart8();
      this.refreshChart9();
    },
    async refreshChart1() {
      const payload = {
        conditions: [
          {
            field: "productSubjectId"
          },
        ],
        dimensions: [
          "productSubjectId",
        ],
        indicators: [
          this.countDistinctUser
        ],
        orders: [
          {
            indicator: this.countDistinctUser,
            orderAsc: false
          }
        ],
        size: 20,
        subject: "lessonLearning"
      }
      let option = this.getDefaultOption();
      option.title = {text: "系列学习人数"};

      this.setTimeParameter(payload);
      let analyseData = await this.getAnalyseData(payload);
      option.xAxis.data = analyseData.data.productSubjectIdDisplay;
      option.series[0].data = analyseData.data.countDistinct_userId;
      this.$refs.chart1.clear();
      this.$refs.chart1.setOption(option);
    },
    async refreshChart2() {
      const payload = {
        conditions: [
          {
            field: "productSubjectId"
          },
          {
            field: "states",
            type: "eq",
            value: 2,
          },
        ],
        dimensions: [
          "productSubjectId",
        ],
        indicators: [
          this.countDistinctUser
        ],
        orders: [{
          indicator: this.countDistinctUser,
        }],
        size: 20,
        subject: "lessonLearning"
      }
      let option = this.getDefaultOption();
      option.title = {text: "系列学习完成人数"};

      this.setTimeParameter(payload);
      let analyseData = await this.getAnalyseData(payload);
      option.xAxis.data = analyseData.data.productSubjectIdDisplay;
      option.series[0].data = analyseData.data.countDistinct_userId;
      this.$refs.chart2.clear();
      this.$refs.chart2.setOption(option);
    },
    async refreshChart3() {
      const payload = {
        conditions: [
          {
            field: "type",
            type: "eq",
            value: 0,
          },
        ],
        dimensions: [
          "lessonId",
        ],
        indicators: [
          {
            field: "correct",
            type: "rate"
          },
        ],
        orders: [{
          indicator: {
            field: "correct",
            type: "rate",
          },
          orderAsc: true
        }],
        size: 100,
        subject: "lessonTest"
      }
      let option = this.getDefaultOption();
      option.title = {text: "课内答题准确率"};

      this.setTimeParameter(payload);
      let analyseData = await this.getAnalyseData(payload);
      let data = analyseData.data;

      option.xAxis.data = data.lessonIdDisplay;
      option.series[0].data = data.rate_correct;
      this.$refs.chart3.clear();
      this.$refs.chart3.setOption(option);
    },
    async refreshChart4() {
      const payload = {
        conditions: [
          {
            field: "type",
            type: "eq",
            value: 1,
          },
        ],
        dimensions: [
          "lessonId",
        ],
        indicators: [
          {
            field: "correct",
            type: "rate"
          },
        ],
        orders: [{
          indicator: {
            field: "correct",
            type: "rate",
          },
        }],
        size: 100,
        subject: "lessonTest"
      }
      let option = this.getDefaultOption();
      option.title = {text: "课后答题准确率"};

      this.setTimeParameter(payload);
      let analyseData = await this.getAnalyseData(payload);
      let data = analyseData.data;
      option.xAxis.data = data.lessonIdDisplay;
      option.series[0].data = data.rate_correct;
      this.$refs.chart4.clear();
      this.$refs.chart4.setOption(option);
    },
    async refreshChart5() {
      const payload = {
        conditions: [
          {
            field: "lessonId",
            type: "neq",
            value: 0
          },
        ],
        dimensions: [
          "lessonId",
        ],
        indicators: [
          {
            field: "time",
            type: "avg"
          },
        ],
        orders: [{
          indicator: {
            field: "time",
            type: "avg",
          },
        }],
        size: 100,
        subject: "learningTime"
      }
      let option = this.getDefaultOption();
      option.title = {text: "课程平均学习(每日/分钟)"};

      this.setStringTimeParameter(payload);
      let analyseData = await this.getAnalyseData(payload);
      let data = analyseData.data;
      option.xAxis.data = data.lessonIdDisplay;
      let avgTime = data.avg_time;
      if (avgTime)
        for (let i = 0; i < avgTime.length; i++) {
          avgTime[i] = (avgTime[i] / 1000 / 60).toFixed(0);
        }
      option.series[0].data = avgTime;
      this.$refs.chart5.clear();
      this.$refs.chart5.setOption(option);
    },
    async refreshChart6() {
      const payload = {
        conditions: [
          {
            field: "costTime",
            type: "neq",
            value: 0
          },
        ],
        dimensions: [
          "lessonId",
        ],
        indicators: [
          {
            field: "costTime",
            type: "avg"
          },
        ],
        orders: [{
          indicator: {
            field: "costTime",
            type: "avg",
          },
        }],
        size: 100,
        subject: "lessonTest"
      }
      let option = this.getDefaultOption();
      option.title = {text: "题目平均回答耗时(秒)"};

      this.setTimeParameter(payload)
      let analyseData = await this.getAnalyseData(payload);
      let data = analyseData.data;
      let avgCostTime = data.avg_costTime;
      if (avgCostTime)
        for (let i = 0; i < avgCostTime.length; i++) {
          avgCostTime[i] = (avgCostTime[i] / 1000).toFixed(1);
        }
      option.xAxis.data = data.lessonIdDisplay;
      option.series[0].data = avgCostTime;
      this.$refs.chart6.clear();
      this.$refs.chart6.setOption(option);
    },
    async refreshChart7() {
      const payload = {
        conditions: [
          {
            field: "grade"
          }
        ],
        dimensions: [
          "lessonId",
        ],
        indicators: [
          {
            field: "grade",
            type: "avg"
          },
        ],
        orders: [{
          indicator: {
            field: "grade",
            type: "avg",
          },
          orderAsc: true
        }],
        size: 20,
        subject: "lessonLearning"
      }
      let option = this.getDefaultOption();
      option.title = {text: "平均评分(满分5)"};

      this.setTimeParameter(payload);
      let analyseData = await this.getAnalyseData(payload);
      let data = analyseData.data;
      let avgGrade = data.avg_grade;
      if (avgGrade)
        for (let i = 0; i < avgGrade.length; i++) {
          avgGrade[i] = (avgGrade[i]).toFixed(1);
        }
      option.xAxis.data = data.lessonIdDisplay;
      option.series[0].data = avgGrade;
      this.$refs.chart7.clear();
      this.$refs.chart7.setOption(option);
    },
    async refreshChart8() {
      const payload = {
        conditions: [],
        dimensions: [
          "rootId",
        ],
        indicators: [
          {
            field: "correct",
            type: "rate"
          },
        ],
        orders: [{
          indicator: {
            field: "correct",
            type: "rate",
          },
          orderAsc: true
        }],
        size: 50,
        subject: "lessonTest"
      }
      let option = this.getDefaultOption();
      option.title = {text: "高错误率问题(%)"};

      this.setTimeParameter(payload);
      let analyseData = await this.getAnalyseData(payload);
      let data = analyseData.data;
      let rateCorrect = data.rate_correct;
      if (rateCorrect)
        for (let i = 0; i < rateCorrect.length; i++) {
          rateCorrect[i] = (100 - rateCorrect[i]).toFixed(1);
        }
      option.xAxis.data = data.rootIdDisplay;
      option.series[0].data = rateCorrect;
      this.$refs.chart8.clear();
      this.$refs.chart8.setOption(option);
    },
    async refreshChart9() {
      const payload = {
        conditions: [],
        dimensions: [
          "lessonId",
        ],
        indicators: [
          {
            field: "total",
            type: "sum"
          },
          {
            field: "finish",
            type: "sum"
          },
        ],
        orders: [],
        size: 100,
        subject: "lessonLearning"
      }
      let option = this.getDefaultOption();
      option.title = {text: "课程完成进度(%)"};

      this.setTimeParameter(payload);
      let analyseData = await this.getAnalyseData(payload);
      let data = analyseData.data;
      let sumTotal = data.sum_total;
      let sumFinish = data.sum_finish;
      let lessonIdDisplay = data.lessonIdDisplay;
      let result = [];
      if (lessonIdDisplay)
        for (let i = 0; i < lessonIdDisplay.length; i++) {
          if (!sumTotal) {
            result.push(0)
          }
          result.push((sumFinish[i] / sumTotal[i] * 100).toFixed(1))
        }
      option.xAxis.data = lessonIdDisplay;
      option.series[0].data = result;
      this.$refs.chart9.clear();
      this.$refs.chart9.setOption(option);
    },
    setTimeParameter(payload) {
      let startTime = this.dateRange[0];
      let endTime = this.dateRange[1];
      if (this.unitName?.length > 0) {
        payload.unitName = this.unitName;
      }
      if (startTime) {
        payload.conditions.push({
          field: "createTime",
          type: "gte",
          value: startTime,
        })
      }
      if (endTime) {
        payload.conditions.push({
          field: "createTime",
          type: "lte",
          value: endTime,
        })
      }
    },
    setStringTimeParameter(payload) {
      let startTime = this.dateRange[0];
      let endTime = this.dateRange[1];
      if (startTime) {
        let stringTime = this.getStringTime(startTime);
        payload.conditions.push({
          field: "date",
          type: "gte",
          value: stringTime
        })
      }
      if (endTime) {
        let stringTime = this.getStringTime(endTime);
        payload.conditions.push({
          field: "date",
          type: "lte",
          value: stringTime
        })
      }
    },
    getStringTime(time) {
      if (!time) return null;
      return DateUtil.formatDateFromTimestamp(time);
    },
    getDefaultOption() {
      return {
        xAxis: {
          data: [],
          axisTick: {
            alignWithLabel: true
          },
        },
        yAxis: {},
        series: [
          {
            barMaxWidth: "20",
            type: "bar",
            data: [],
          },
        ],
        color: "#10689c",
        dataZoom: [
          {
            type: 'slider',
            xAxisIndex: [0, 1],
            realtime: false,
            start: 0,
            end: 20,
            minValueSpan: 20,
          },
          {
            type: 'inside',
          }
        ],
        tooltip: {
          show: true,
          triggerOn: 'mousemove|click',
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.TeachingData {
  .appBox {
    min-height: calc(100vh - 155px);

    .echarts-div {
      width: 50%;
    }

    .echarts {
      width: 100%;
      height: 300px;
    }
  }
}
</style>
